import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAL0hnRNISrL4pWNycO607oI2yH3bTjpGI',
  authDomain: 'parrotai-433712.firebaseapp.com',
  projectId: 'parrotai-433712',
  storageBucket: 'parrotai-433712.firebasestorage.app',
  messagingSenderId: '283170355185',
  appId: '1:283170355185:web:39cd3bbcd04209047cf650',
  measurementId: 'G-ZS384LVTPX',
};

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
// This named Enterprise database is isolated from the shared Standard default.
export const databaseId = 'parrotsuite';
export const db = getFirestore(app, databaseId);

// Analytics is optional and must never prevent authentication from starting.
export async function initializeAnalytics() {
  if (process.env.REACT_APP_ENABLE_ANALYTICS !== 'true') return null;
  try {
    const { getAnalytics, isSupported } = await import('firebase/analytics');
    return (await isSupported()) ? getAnalytics(app) : null;
  } catch {
    return null;
  }
}
